import { Id } from 'types/definitions'
import { task } from 'mobx-task'
import { action, computed, makeObservable } from 'mobx'
import { Env } from 'infra/env'
import TxfJobStore from 'jobs/TxfJobStore'
import { isNotNil } from 'utils/object-util'
import Job from 'jobs/Job'
import { GetCurrentMember } from 'iam/SessionStore'
import DocumentStore from 'documents/DocumentStore'

export default class TxfJobViewModel {
  constructor(
    private job: Job,
    private getCurrentMember: GetCurrentMember,
    private txfJobStore: TxfJobStore,
    private documentStore: DocumentStore,
  ) {
    makeObservable(this, {
      hasPermission: computed,
      hasIntegration: computed,
      hasDocuments: computed,
      canView: computed,
      viewInTxf: action,
    })
  }

  get hasPermission() {
    const currentMember = this.getCurrentMember(this.job.workspace.id)

    return (
      currentMember.hasPermission('ADMIN_VIEW_TXF_WORKLAYER_JOB') ||
      this.job.championProvider?.member.user.id === currentMember.user.id
    )
  }

  get hasIntegration() {
    return isNotNil(this.txfJobStore.forJob(this.job.id))
  }

  get hasDocuments() {
    return this.documentStore
      .forJob(Id.assert(this.job.id))
      .some((document) => !document.archived)
  }

  get canView() {
    return this.hasDocuments && this.hasIntegration && this.hasPermission
  }

  viewInTxf() {
    window.open(
      `${Env.TXF_PORTAL_URL}/job/${this.job.id}`,
      '_blank',
      'noopener,noreferrer',
    )
  }

  activate = task.resolved(async () => {
    if (this.hasIntegration || !this.hasPermission) {
      return
    }

    await this.txfJobStore.fetchTxfJob(this.job.id)
  })
}
